import { render } from "./RegisterModal.vue?vue&type=template&id=2787fcd2"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"
script.render = render

export default script